import React from 'react';
import { Outlet } from 'react-router-dom';
import SideBar from './SideBar';
import { useTheme, useMediaQuery } from '@mui/material';

const drawerWidth = 300;

const Dashboard = () => {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

    const contentStyles = {
        marginLeft: isLargeScreen ? `${drawerWidth}px` : 0,
        padding: '16px',
    };

    return (
        <div className="dashboard-container">
            <SideBar />
            <div className="dashboard-content" style={contentStyles}>
                <Outlet />
            </div>
        </div>
    );
};

export default Dashboard;
